'use client';

import { useState } from 'react';

import { useActivitiesByProfessionalId } from '@website/hooks/useActivitiesByProfessional';
import { Activity } from '@website/services/activities.service';

import { PeriodType } from '../app/[locale]/_components/dashboard/types';

export const useDashboardState = (userId: string) => {
  const [period, setPeriod] = useState<PeriodType>('daily');
  const [selectedActivityId, setSelectedActivityId] = useState<string>('');

  const { data: professionalActivities = [] } = useActivitiesByProfessionalId(userId, '');

  const activityOptions = professionalActivities.map((activity: Activity) => ({
    value: activity.id,
    label: activity.title
  }));

  return {
    period,
    setPeriod,
    selectedActivityId,
    setSelectedActivityId,
    activityOptions
  };
};
